// @ts-nocheck
// eslint-disable-next-line standard/object-curly-even-spacing
import {postApiData, getApiData } from './common'
const loginApi = {
  getVerifyCodeImg(params) {
    return getApiData('/openApi/login/identifyCode', params)
  },
  loginOut(params) {
    return getApiData('/api/user/loginOut', params)
  },
  loginValidByAccount(params) {
    return postApiData('/openApi/login/valid', params)
  }
}

export {
  loginApi
}
